import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  Drawer,
  DrawerHeader,
  DrawerContent
} from 'rmwc/Drawer';

import {
  List,
  ListItem,
  ListItemText
} from 'rmwc/List';
import { connect } from 'react-redux'


class SideBar extends Component {
  constructor(props) {
    super(props) 
  }
  render() {

    let userMenuItems
    let adminMenuItems
    let reviewerMenuItems
    let institutionAdminMenuItems

    if(this.props.user.role === 'user'){
      userMenuItems = (
        <DrawerContent className="left-menu-list">
          <ListItem className="menu-list">
            <Link to="/portal/app/profile" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">perm_identity</i><greytext>Profile</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/user/about/tpo" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">local_activity</i><greytext>Get Certified</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/my_registrations" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">receipt</i><greytext>My Registrations</greytext>
            </Link>
          </ListItem>
          
          {/*<ListItem className="menu-list">
            <Link to="/portal/app/submission_parent" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">view_carousel</i><greytext>My Submissions</greytext>
            </Link>
          </ListItem>*/}
          {/*<ListItem className="menu-list">
            <Link to="/portal/app/tpo_certification_report" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">poll</i><greytext>My Performance Reports</greytext>
            </Link>
          </ListItem>*/}
          {/**<ListItem className="menu-list">
            <Link to="/portal/app/purchase/landing" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">poll</i><greytext>Affiliated Programs</greytext>
            </Link>
          </ListItem>

          <ListItem>
            <Link to="/portal/app/purchase/orders" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>My Orders</greytext>
              </Link>
          </ListItem>
          */}
         {/* <ListItem className="menu-list">
            <Link to="/portal/app/learning_resources/my_learning_plan" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">fitness_center</i><greytext>My Learning Plan</greytext>
            </Link>
          </ListItem>*/}
          <ListItem className="menu-list">
            <Link to="/portal/app/user/questionnaires" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">list_alt</i><greytext>Quizzes & Surveys</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
              <Link to="/portal/app/opportunities" className="mdc-list-item demo-drawer-list-item">
                  <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">ballot</i><greytext>Career Opportunities</greytext>
              </Link>
          </ListItem>
          <ListItem className="menu-list">
              <Link to="/portal/app/user_referral" className="mdc-list-item demo-drawer-list-item">
                  <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">group_add</i><greytext>Invite your Friend</greytext>
              </Link>
          </ListItem>
          <ListItem className="menu-list">
              <Link to="/portal/app/user/activity_main_page" className="mdc-list-item demo-drawer-list-item">
                  <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">track_changes</i><greytext>Chalk Points</greytext>
              </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/password_reset" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Reset Username/Password</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent>)
      
    }
    
    else if(this.props.user.role === 'admin'){
      adminMenuItems = (
        <DrawerContent>
          {/*<ListItem id="icon-with-text-demo">
            <Link to="/portal/app/admin/opportunities" className="mdc-list-item demo-drawer-list-item" href="/portal/app/opportunities/new">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>Opportunity</greytext>
            </Link>
          </ListItem>*/}
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/reg_user_details" className="mdc-list-item demo-drawer-list-item" href="/portal/app/reg_user_details">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">group</i><greytext>User Details</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/admin/user/import/home" className="mdc-list-item demo-drawer-list-item" href="/portal/app/admin/user/import/home">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">publish</i><greytext>User Upload</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/tpo_reg_users" className="mdc-list-item demo-drawer-list-item" href="/portal/app/tpo_reg_users">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>TPO Registrations</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/admin/tpo_report/download_count" className="mdc-list-item demo-drawer-list-item" href="/portal/app/tpo_reg_users">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">chat</i><greytext>TPO Report Details</greytext>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/tpo_registration_status" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>TPO Registrations Status</greytext>
              </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/mc_reg_users" className="mdc-list-item demo-drawer-list-item" href="/portal/app/mc_reg_users">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">confirmation_number</i><greytext>MC Registrations</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/fc_reg_users" className="mdc-list-item demo-drawer-list-item" href="/portal/app/fc_reg_users">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">beenhere</i><greytext>FC Registrations</greytext>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/tq_registration" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>TQ Registrations</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/tq/reports/home" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">publish</i><greytext>TQ Report Scores Upload</greytext>
              </Link>
          </ListItem>
           <ListItem>
            <Link to="/portal/app/registration_fees" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">euro_symbol</i><greytext>Registration Fees</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/seminar/list" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">card_membership</i><greytext>Webinars</greytext>
              </Link>
          </ListItem>
           <ListItem>
            <Link to="/portal/app/admin/questionnaire/home" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">card_membership</i><greytext>Questionnaires</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/coupons" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">card_membership</i><greytext>Coupons</greytext>
              </Link>
          </ListItem>
           <ListItem>
            <Link to="/portal/app/admin/tpo_admin_upload" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>TPO Questions</greytext>
              </Link>
          </ListItem>
           <ListItem>
            <Link to="/portal/app/admin/course/entity/home" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>Course Package</greytext>
              </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/admin_user_referral" className="mdc-list-item demo-drawer-list-item" href="/portal/app/fc_reg_users">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>User Referrals</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/admin/rewards_section" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">card_giftcard</i><greytext>Chalk points</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/admin/hallticket" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Hall Ticket Details</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/admin/resource_and_question_of_the_day/both" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Change Resource/Question of the day</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/password_reset" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>UserName / Password Reset</greytext>
            </Link>
          </ListItem>        
          {/*<ListItem className="menu-list">
            <Link to="/portal/app/admin/change_pwa_banner" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Change PWA Dashboard Banners</greytext>
            </Link>
          </ListItem>*/}
          <ListItem className="menu-list">
            <Link to="/portal/app/admin/pwa_app_version" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Change App Version</greytext>
             </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/display/configuration/home" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">settings</i><greytext>Display Configuration</greytext>
             </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/fetch/currency/exchange/rate" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">account_balance</i><greytext>Change Currency Exchange Rate</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>Logout</greytext>
              </Link>
          </ListItem>


        </DrawerContent> )
    }

    else if(this.props.user.role === 'reviewer'){
      reviewerMenuItems = (
        <DrawerContent>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/reviewer/fc_parent" className="mdc-list-item demo-drawer-list-item" href="#">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>FC List</greytext>
            </Link>
          </ListItem>

          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/reviewer/mc_parent" className="mdc-list-item demo-drawer-list-item" href="#">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>MC List</greytext>
            </Link>
          </ListItem>
          <ListItem id="icon-with-text-demo">
            <Link to="/portal/app/reviewer/tq_parent" className="mdc-list-item demo-drawer-list-item" href="#">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">inbox</i><greytext>TQ List</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/password_reset" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>UserName / Password Reset</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">no_encryption</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent> )
    }
    else if(this.props.user.role === 'lr_admin'){
      reviewerMenuItems = (
        <DrawerContent>
          <ListItem className="menu-list">
            <Link to="/portal/app/admin/learning_taxonomies" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">dashboard</i><greytext>Learning Resources</greytext>
            </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/render_learning_resources" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">table_chart</i><greytext>Consolidated Resources View</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/user_resource/submitted_response" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">view_day</i><greytext>User Resources</greytext>
              </Link>
          </ListItem>
          <ListItem>
            <Link to="/portal/app/admin/submitted_modules" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">subtitles</i><greytext>Partner Resources</greytext>
              </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/password_reset" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>UserName / Password Reset</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">power_settings_new</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent> )
    }

    else if(this.props.user.role === 'institution_admin'){
      institutionAdminMenuItems = (
        <DrawerContent>
          <ListItem>
            <Link to="/portal/app/instadmin/instgroupreport" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Report</greytext>
              </Link>
          </ListItem>

          <ListItem>
            <Link to="/portal/app/institute/userdetail" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Search TQ User</greytext>
              </Link>
          </ListItem>

          <ListItem>
            <Link to="/portal/app/institute/userdetail_list" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>TQ Registration List</greytext>
              </Link>
          </ListItem>
          
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">power_settings_new</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent> )
    }

    else if(this.props.user.role === 'affiliate_partner'){
      institutionAdminMenuItems = (
        <DrawerContent>
          <ListItem>
            <Link to="/portal/app/user/affiliate_partner/initiate_module" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">widgets</i><greytext>Modules Upload</greytext>
              </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/app/password_reset" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>UserName / Password Reset</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">power_settings_new</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent> )
    }

    else if(this.props.user.role === 'hallticket_admin') {
      adminMenuItems = (
        <DrawerContent>
          <ListItem className="menu-list">
            <Link to="/portal/app/admin/hallticket/details" className="mdc-list-item demo-drawer-list-item">
              <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">import_contacts</i><greytext>Hall Ticket Details</greytext>
            </Link>
          </ListItem>
          <ListItem className="menu-list">
            <Link to="/portal/logout" className="mdc-list-item demo-drawer-list-item" href="#">
                <i className="material-icons mdc-list-item__graphic nav-menu-icon" aria-hidden="true">power_settings_new</i><greytext>Logout</greytext>
              </Link>
          </ListItem>
        </DrawerContent>
      )
    }

    return (
    <Drawer persistent  open={this.props.menuState}  id="main-nav">
      <div className = "menu-panel">
      {userMenuItems}
      {adminMenuItems}
      {reviewerMenuItems}
      {institutionAdminMenuItems}
      </div>
    </Drawer>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)







// WEBPACK FOOTER //
// ./src/layout/SideBar.jsx